import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
const useIssueCountsLabel = (errorCount, warningCount) => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "agentBuilder.canvas.validations"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t0);
  let parts;
  if ($[1] !== errorCount || $[2] !== t || $[3] !== warningCount) {
    parts = [];
    if (errorCount > 0) {
      let t1;
      if ($[5] !== errorCount || $[6] !== t) {
        t1 = errorCount === 1 ? t(_temp, {
          count: 1
        }) : t(_temp2, {
          count: errorCount
        });
        $[5] = errorCount;
        $[6] = t;
        $[7] = t1;
      } else {
        t1 = $[7];
      }
      parts.push(t1);
    }
    if (warningCount > 0) {
      let t1;
      if ($[8] !== t || $[9] !== warningCount) {
        t1 = warningCount === 1 ? t(_temp3, {
          count: 1
        }) : t(_temp4, {
          count: warningCount
        });
        $[8] = t;
        $[9] = warningCount;
        $[10] = t1;
      } else {
        t1 = $[10];
      }
      parts.push(t1);
    }
    $[1] = errorCount;
    $[2] = t;
    $[3] = warningCount;
    $[4] = parts;
  } else {
    parts = $[4];
  }
  return parts.join(", ");
};
export default useIssueCountsLabel;
function _temp($) {
  return $.error_one;
}
function _temp2($_0) {
  return $_0.error_other;
}
function _temp3($_1) {
  return $_1.warning_one;
}
function _temp4($_2) {
  return $_2.warning_other;
}